import React from 'react'
import {styled} from '@material-ui/core/styles'
import {Button as MuiButton} from '@material-ui/core'
import {openRfpDialog} from 'rfps/store/actions'
import {useDispatch, useSelector} from 'react-redux'
import Tooltip from '@material-ui/core/Tooltip'
import history from 'utils/history'
import {getCurrentUser} from 'users/store/selectors'
import ScheduleDemoButton from 'lms/components/ScheduleDemoButton'

const Content = styled('div')({
  margin: 0,
  marginBottom: 10,
  display: 'flex',
  flexDirection: 'column'
})

const TextContainer = styled('div')({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 4,
  WebkitBoxOrient: 'vertical',
})

const ButtonContainer = styled('div')({
  marginTop: '.5rem'
})

const ButtonWithoutShadow = styled(MuiButton)({
  boxShadow: 'none'
})

const Description = ({
  description = '',
  systemId,
  isGuestUser,
  isPremium,
  showDialog,
  calendarUrl,
  ...props
}) => {  
  const dispatchRedux = useDispatch()
  const currentUser = useSelector(getCurrentUser)
  const isLong = description.length > 500

  let shortDescription = description.substring(0, 499)

  const text = shortDescription  

  const handleRequestPricing = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!isGuestUser) {
      dispatchRedux(openRfpDialog(systemId))
    } else {
      // go so signup
      history.push('/register')
    }
  }

  let buttonText = 'Request Information'
  let disabled, hasRequestedQuote

  if (
    currentUser &&
    currentUser.rfps &&
    currentUser.rfps.some(r => r.application === systemId)
  ) {
    buttonText = 'Information Requested'
    disabled = true
    hasRequestedQuote = true
  }

  let ellipsis
  if (isLong) {
    ellipsis = <span>&hellip; </span>
  }

  const expandButton = (
    <ButtonWithoutShadow
      color='primary'
      variant='contained'
      style={{marginRight: '1rem'}}
    >
      Read More
    </ButtonWithoutShadow>
  )

  return (
    <Content {...props}>
      <TextContainer>
        {text}
        {ellipsis}
      </TextContainer>
      <ButtonContainer>
        {expandButton}
        {isPremium &&
          <Tooltip
            title='Create a FREE account to access this feature'
            disableHoverListener={!isGuestUser}
          >
            <span>
              <MuiButton
                onClick={handleRequestPricing}
                color='primary'
                variant='outlined'
                disabled={disabled}
                style={{
                  color: isGuestUser
                    ? '#D3D3D3'
                    : hasRequestedQuote
                      ? 'rgb(67, 160, 71)'
                      : '',
                  border: `1px solid ${
                    isGuestUser || hasRequestedQuote ? '#D3D3D3' : ''
                  }`
                }}
              >
                {buttonText}
              </MuiButton>
            </span>
          </Tooltip>
        }
        <ScheduleDemoButton
          calendarUrl={calendarUrl}
          systemId={systemId}
          style={{marginLeft: '0.5rem'}}
        />
      </ButtonContainer>
    </Content>
  )
}

export default Description
